module.exports = __webpack_public_path__ + "img/savingnotes.203df72f.png";